import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import RaffleCard from "@/components/RaffleCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Raffles() {
  const [raffles, setRaffles] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("TODAS");

  useEffect(() => {
    api.get("/raffles").then(({ data }) => setRaffles(data)).catch(() => {});
  }, []);

  const cats = ["TODAS", "AUTO", "LUXO", "TECH", "PIX"];
  const filtered = raffles.filter((r) => {
    if (cat !== "TODAS" && (r.category || "LUXO") !== cat) return false;
    if (q && !r.title.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-200/80 mb-2">Rifas ativas</p>
        <h1 className="heading text-3xl sm:text-5xl font-extrabold text-slate-50">Todas as <span className="gold-gradient-text">rifas</span></h1>
      </div>
      <div className="flex flex-wrap items-center gap-3 mb-8">
        <div className="relative flex-1 min-w-[240px] max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar rifa..."
            data-testid="search-raffles"
            className="pl-9 bg-slate-950 border-white/10 text-slate-100"
          />
        </div>
        <div className="flex gap-2 flex-wrap">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`filter-${c}`}
              className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest border transition-all ${
                cat === c ? "gold-btn border-transparent" : "border-white/10 text-slate-300 hover:border-amber-400/40"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((r) => <RaffleCard key={r.raffle_id} raffle={r} />)}
      </div>
      {filtered.length === 0 && (
        <div className="text-center py-20 text-slate-400">Nenhuma rifa encontrada.</div>
      )}
    </div>
  );
}
